'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { CREATE_MENU, DELETE_MENU, PUBLISH_MENU, DISCARD_MENU_BUFFER, FETCH_MENU_BUFFER, RENAME_MENU, REVERT_MENU, SAVE_MENU_BUFFER } from 'advanced-menus-core/actions/ActionTypes';
function menuBuffersById(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case FETCH_MENU_BUFFER:
    case SAVE_MENU_BUFFER:
    case DISCARD_MENU_BUFFER:
    case REVERT_MENU:
      {
        const {
          menu
        } = action;
        if (menu) {
          return state.set(menu.id, menu);
        }
        return state;
      }
    case CREATE_MENU:
    case PUBLISH_MENU:
      {
        const {
          menu
        } = action;
        if (menu) {
          return state.set(menu.id, Object.assign({}, menu));
        }
        return state;
      }
    case RENAME_MENU:
      {
        const {
          menu
        } = action;
        if (menu) {
          const existingBuffer = state[menu.id];
          if (existingBuffer) {
            const updatedBuffer = existingBuffer.merge({
              name: menu.name,
              label: menu.label,
              updated: menu.updated
            });
            return state.set(menu.id, updatedBuffer);
          }
          return state.set(menu.id, menu);
        }
        return state;
      }
    case DELETE_MENU:
      {
        const {
          menuId,
          deleted
        } = action;
        if (deleted) {
          return state.without(menuId);
        }
        return state;
      }
    default:
      {
        return state;
      }
  }
}
function status(state = SeamlessImmutable({
  isFetching: false,
  fetchError: null,
  isSaving: false,
  saveError: null,
  isDiscarding: false,
  discardError: null
}), action) {
  switch (action.type) {
    case FETCH_MENU_BUFFER:
      {
        const {
          error,
          menu
        } = action;
        return state.merge({
          isFetching: !(error || menu),
          fetchError: error || null
        });
      }
    case SAVE_MENU_BUFFER:
      {
        const {
          error,
          menu
        } = action;
        return state.merge({
          isSaving: !(error || menu),
          saveError: error || null
        });
      }
    case DISCARD_MENU_BUFFER:
      {
        const {
          error,
          menu
        } = action;
        return state.merge({
          isDiscarding: !(error || menu),
          discardError: error || null
        });
      }
    default:
      {
        return state;
      }
  }
}
function bufferDiscardedTime(state = 0, action) {
  switch (action.type) {
    case DISCARD_MENU_BUFFER:
      {
        const {
          menu
        } = action;
        if (menu) {
          const now = new Date();
          return now.getTime();
        }
        return state;
      }
    default:
      {
        return state;
      }
  }
}
export default combineReducers({
  menuBuffersById,
  status,
  bufferDiscardedTime
});